import PropTypes from 'prop-types';

/**
 * The preferences picked in the Preference Amenities dropdown, listed under
 * it as green badges, each with its own ✕ to take it off again.
 */
export default function AmenityChips({ items, onRemove, disabled = false }) {
  if (!items?.length) return null;

  return (
    <div className="nb-chips">
      {items.map((item) => (
        <span key={item.value} className="nb-chip">
          {item.label}
          <button type="button" aria-label={`Remove ${item.label}`} disabled={disabled} onClick={() => onRemove(item)}>
            <i className="ph ph-x" />
          </button>
        </span>
      ))}
    </div>
  );
}

AmenityChips.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.node })),
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
